import howItWorks from './howItworks';
import features from './features';
import why from './why';
import stories from './stories';

export default {
    features,
    howItWorks,
    why,
    stories,
};
